import { Button, IconButton } from '@chakra-ui/react';
import { FaQuestionCircle } from 'react-icons/fa';

export interface HelpButtonProps {
    buttonLabel?: string;
    buttonIcon?: any;
    title?: string;
    content?: React.ReactNode;
    // size?: string;
    onClick?: any;
    [x: string]: any;
}

export const HelpButton: React.FC<HelpButtonProps> = ({
    buttonLabel,
    buttonIcon = <FaQuestionCircle />,
    title,
    content,
    size = 'xs',
    onClick,
    ...rest
}) => {
    return (
        <>
            {buttonLabel ? (
                buttonIcon ? (
                    <Button size={size} leftIcon={buttonIcon} onClick={onClick}>
                        {buttonLabel}
                    </Button>
                ) : (
                    <Button size={size}>{buttonLabel}</Button>
                )
            ) : (
                <IconButton
                    {...rest}
                    size={size}
                    aria-label="help"
                    icon={buttonIcon}
                    onClick={onClick}
                ></IconButton>
            )}
        </>
    );
};
